<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{ modalTitle }}</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="row">

      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
        <div *ngFor="let validation of msg">
          <div class="error-message"
            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
            {{validation.message}}
          </div>
        </div>
      </ng-template>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{generalLang?.code}}</label>
          <input type="text" class="form-control" formControlName="skill_code"
            [ngClass]="formErrorClass(createForm.controls.skill_code, createFormSubmitted)">


          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.skill_code, value:createForm.controls.skill_code, submitted:createFormSubmitted }">
          </ng-template>
        </div>

      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{generalLang?.desc}}</label>
          <textarea class="form-control" formControlName="skill_description" [ngClass]="formErrorClass(createForm.controls.skill_description, createFormSubmitted)"></textarea>

      </div>
    </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-6">
          <label>{{generalLang?.how_often_repeat}}</label>
          <input type="text" class="form-control" formControlName="repeat_period"
            [ngClass]="formErrorClass(createForm.controls.repeat_period, createFormSubmitted)" pattern="[0-9]+" ng-pattern-restrict>

            <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.repeat_period, value:createForm.controls.repeat_period, submitted:createFormSubmitted }">
          </ng-template>

        </div>

        <div class="form-group col-sm-6">
          <label></label>
          <select class="form-control" formControlName="rep_types"
          [ngClass]="formErrorClass(createForm.controls.rep_types, createFormSubmitted)">
          <option value="">{{generalLang?.select}}</option>
          <option *ngFor="let type of RepTypes" [ngValue]="type.value">{{type.text}}</option>
        </select>

        </div>
      </div>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{generalLang?.notify_time}}</label>
          <input type="text" class="form-control" formControlName="notify_time"
            [ngClass]="formErrorClass(createForm.controls.notify_time, createFormSubmitted)">

        </div>
      </div>

     

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{generalLang?.level_of_competence}}</label>
          <select class="form-control" formControlName="level_of_competence"
          [ngClass]="formErrorClass(createForm.controls.level_of_competence, createFormSubmitted)">
          <option value="">{{generalLang?.select}}</option>
          <option *ngFor="let type of LevelCompetence" [ngValue]="type.value">{{type.text}}</option>
        </select>

          <ng-template [ngTemplateOutlet]="ErrorMsg"
          [ngTemplateOutletContext]="{msg:createFormErrorMsg.level_of_competence, value:createForm.controls.level_of_competence, submitted:createFormSubmitted }">
        </ng-template>



        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{generalLang?.employee_to_which_skilss}}</label>
          <ng-multiselect-dropdown [placeholder]="generalLang?.select" formControlName="employee_skills_applies" [data]="emp_skills" [settings]="dropdownSettings">
          </ng-multiselect-dropdown>



        </div>
      </div>

      <div class="form-group col-sm-12">
      <div class="form-group col-sm-12" formArrayName="send_email">
        <label>{{generalLang?.ref_mail}}</label>
        <div class="form-group row" *ngFor="let email of send_email().controls; let i=index">
          <div class="col-sm-11">
            <input type="text" class="form-control" formControlName="{{i}}" [ngClass]="formErrorClass(send_email().controls[i], createFormSubmitted)">
            
            <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.send_email, value:send_email().controls[i], submitted:createFormSubmitted }"></ng-template>

          </div>
          <div class="col-sm-1">
            <button class="btn btn-primary pull-right" type="button" (click)="removeEmail(i)" *ngIf=" i!=(send_email().controls.length-1) ">
              <i class="fa fa-trash-o"></i>
            </button>
            <button class="btn btn-primary pull-right" type="button" (click)="addEmail()" *ngIf=" i==(send_email().controls.length-1) ">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </div> 


    </div>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-success">{{ generalLang.save }}</button>
    <!-- <button class="btn btn-warning" data-dismiss="modal" (click)="bsModalRef.hide()">Close</button> -->
    <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">{{ generalLang.close }}</button>

  </div>
</form>

<ng-template #imagePreviewRef let-link='imageLink'>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Image Preview</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body section-spaces">
    <app-image-preview [imageUrl]="imageLink"></app-image-preview>
  </div>
</ng-template>